<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@wielink-application/shared/js/mixins/formInput";
import DateTime from "@/pages/components/form/input-only/datetime.vue";
import Input from "@/pages/components/form/input-only/color.vue";


export default {
  mixins: [formInput],
  components: {Input, FormGroup, DateTime},
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  }
}
</script>

<template>
  <FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
    <template #label>{{ label }}</template>

    <DateTime
        v-bind="$attrs"
        :name="name"
        :form="form"
        :id="renderedId"
        :model-value="modelValue"
        @update:modelValue="changeModelValueTo"
    />
  </FormGroup>
</template>